import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid, Row, Col } from 'react-bootstrap';
import ShsLogo from '../../../resources/SHS_Logo.png';
import './SHSbyAsurionTitleBar.scss';

class SHSbyAsurionTitleBar extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="SHSbyAsurionTitleBarContainer">
        <Grid>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12}>
              <img className="ShsLogo" src={ShsLogo} alt="Smart Home Support By Asurion" />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (/*state, ownProps*/) => ({});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SHSbyAsurionTitleBar);



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/components/shs/SHSbyAsurionTitleBar/SHSbyAsurionTitleBar.js